module.exports = __webpack_public_path__ + "img/tbt830-1-1993.prt.950ff94e.jpg";